import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { TeamDirectType, TeamStructureUserType } from './types';
import {
  formatUSDNoDecimals,
  handleValidDate,
  handleValidTime
} from '../../../helpers/helpers';

export const getTeamStructureById = createAsyncThunk(
  'teams/getTeamStructureById',
  async (id: string) => {
    const response = await axiosInstance.get(
      `/mlm/user/team/${id}?levelCount=5`
    );

    return response.data.data.teamUser as TeamStructureUserType;
  }
);

export const getTeamDirectById = createAsyncThunk(
  'teams/getTeamDirectById',
  async (id: string) => {
    const response = await axiosInstance.get(`/mlm/user/team/direct/${id}`);
    return response.data.data as TeamDirectType;
  }
);

export const getTeamTradingById = createAsyncThunk(
  'teams/getTeamTradingById',
  async (id: string) => {
    const response = await axiosInstance.get(
      `/mlm/user/team/trading/${id}?levelCount=5`
    );

    return response.data.data.teamUser as TeamStructureUserType;
  }
);

export const exportTeams = createAsyncThunk(
  'teams/exportTeams',
  async (id: number) => {
    const response = await axiosInstance.get(
      `/mlm/user/team/unilevel/csv/${id}`
    );

    const mapped = response.data
      .trim()
      .split('\n')
      .slice(1)
      .map((row: string) => {
        const [userId, referrerId] = row.split(',');
        return {
          userId: +userId,
          referrerId: +referrerId
        };
      });

    const dataForExport = mapped.map((po: any) => ({
      userId: po?.userId,
      referrerId: po?.referrerId
    }));

    return dataForExport;
  }
);

export const resetState = createAsyncThunk('teams/resetState', async () => {
  return {
    structure: {} as TeamStructureUserType,
    direct: {} as TeamDirectType,
    trading: {} as TeamStructureUserType
  };
});

export const exportHeaders = [
  { label: 'User ID', key: 'userId' },
  { label: 'ReferrerId', key: 'referrerId' }
];

export interface TeamsState {
  structure: TeamStructureUserType;
  direct: TeamDirectType;
  trading: TeamStructureUserType;
  loading: boolean;
  dataForExport: any;
  loadingExport: boolean;
}

const initialState = {
  structure: {},
  direct: {},
  trading: {},
  loading: false,
  dataForExport: [],
  loadingExport: false
} as TeamsState;

const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    // resetTeams: () => initialState,
    removeTeamsForExport(state) {
      state.dataForExport = [];
    }

    // fill in primary logic here
  },
  extraReducers: (builder) => {
    //TEAM STRUCTURE
    builder.addCase(getTeamStructureById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeamStructureById.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.structure = payload;
    });
    builder.addCase(getTeamStructureById.rejected, (state) => {
      state.loading = false;
    });
    //DIRECT
    builder.addCase(getTeamDirectById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeamDirectById.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.direct = payload;
    });
    builder.addCase(getTeamDirectById.rejected, (state) => {
      state.loading = false;
    });
    //TRADING STRUCTURE
    builder.addCase(getTeamTradingById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeamTradingById.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.trading = payload;
    });
    builder.addCase(getTeamTradingById.rejected, (state) => {
      state.loading = false;
    });

    //EXPORT TEAMS
    builder.addCase(exportTeams.pending, (state) => {
      state.loadingExport = true;
    });
    builder.addCase(exportTeams.fulfilled, (state, { payload }) => {
      state.loadingExport = false;
      state.dataForExport = payload;
    });
    builder.addCase(exportTeams.rejected, (state) => {
      state.loadingExport = false;
    });

    // //resest
    // builder.addCase(resetState.pending, (state) => {});
    // builder.addCase(resetState.fulfilled, (state, { payload }) => {
    //   state.structure = payload.structure;
    //   state.direct = payload.direct;
    //   state.trading = payload.trading;
    // });
    // builder.addCase(resetState.rejected, (state) => {});
  }
});

export const { removeTeamsForExport } = teamsSlice.actions;

export default teamsSlice.reducer;
